import React from 'react';

function Contributors() {

  return (
    <div className='Footer'>
        <div className='Contributors'>
            <h1>Thank you to our contributors!</h1>
            <h2>California State University, Long Beach</h2>
                <li>Melissa Bittner, PhD <a href='mailto:melissa.bittner@csulb.edu?subject=APE Assessment Tools'>(melissa.bittner@csulb.edu)</a></li>
                <li>Amanda Young, PhD</li>
                <li>Barry Lavay, PhD</li>
                <li>Adrienne Alaniz, Project CAPE Scholar</li>
                <li>Katrina Orevillo, Developer</li>
            <h2>University of Wisconsin, Stevens Point</h2>
                <li>Kristi Roth, PhD</li>
        </div>
    </div>
  );
}

export default Contributors;
